// extracted by mini-css-extract-plugin
export default {"button":"Button_button__wiIYs","primary":"Button_primary__XYgy-","outline":"Button_outline__B6Yol","outlineDanger":"Button_outlineDanger__46Veo","danger":"Button_danger__BMjE6"};